import authService from './authService';

const AGENT_PARENT_API_URL = process.env.REACT_APP_AGENT_PARENT_API_URL || 'https://your-agent-parent-api-url.execute-api.us-east-1.amazonaws.com/prod';

const secretsService = {
  /**
   * Get all secrets for the current user
   */
  async getSecrets() {
    try {
      // API Gateway Cognito authorizers use ID tokens, not access tokens
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/secrets`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch secrets');
      }

      const data = await response.json();
      return data.secrets || [];
    } catch (error) {
      console.error('Error fetching secrets:', error);
      throw error;
    }
  },

  /**
   * Add or update a secret
   */
  async putSecret(secretKey, secretValue) {
    try {
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/secrets`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
        body: JSON.stringify({
          secretKey,
          secretValue,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to save secret');
      }

      return await response.json();
    } catch (error) {
      console.error('Error saving secret:', error);
      throw error;
    }
  },

  /**
   * Delete a secret
   */
  async deleteSecret(secretKey) {
    try {
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/secrets?secretKey=${encodeURIComponent(secretKey)}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to delete secret');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting secret:', error);
      throw error;
    }
  },
};

export default secretsService;
